// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/sidebar-header/style.scss
// module id = 442
// module chunks = 0 1